import { RootState } from '../../store';

export const getCurrentCustomerIdSelector = (state: RootState) => state?.ticketReducer?.currentCustomerId;
